export enum InsoleFootEnum {
  Left = 0,
  Right = 1,
}
